import React from 'react';
import { block } from '../../utils';
import TrackAssetBody from './TrackAssetBody';
import TrackAssetContainer, {
  TrackAssetContainerProps,
} from './TrackAssetContainer';
import { TrackAssetProvider } from './TrackAssetContext';
import TrackAssetItem, { TrackAssetItemProps } from './TrackAssetItem';
import { TrackAssetProviderProps } from './types';

export type TrackAssetProps = Omit<TrackAssetProviderProps, 'children'> &
  Omit<TrackAssetContainerProps, 'children'> &
  Pick<TrackAssetItemProps, 'handleClassName'> & {
    children?: React.ReactNode;
    eyebrow?: React.ReactNode;
    itemClassName?: string;
    /*
     * higher number brings the asset forward
     */
    order?: number;
  };

function TrackAsset(props: TrackAssetProps): React.ReactElement {
  const { children, eyebrow, handleClassName, itemClassName, order } = props;

  const hasEyebrow = !!eyebrow;

  return (
    // passes state through the track asset tree
    <TrackAssetProvider {...props}>
      {/* the container is the main draggable element of the asset.  the Draggable
          component doesn't add any markup. the props for wiring up dragging are
          exposed via the child render function */}
      <TrackAssetContainer {...props}>
        {({ style: draggableStyle, ...draggableProps }) => (
          // creates space for the asset.  the body receives the draggable style
          // prop so that it gets the correct width
          <TrackAssetBody
            fluid={hasEyebrow}
            order={order}
            style={draggableStyle}
          >
            {eyebrow && (
              <div className={block('track-asset-eyebrow')}>{eyebrow}</div>
            )}
            {/* the item holds the visible content of the asset and responds to drag events */}
            <TrackAssetItem
              className={itemClassName}
              handleClassName={handleClassName}
              {...draggableProps}
            >
              {children}
            </TrackAssetItem>
          </TrackAssetBody>
        )}
      </TrackAssetContainer>
    </TrackAssetProvider>
  );
}

export default TrackAsset;
